import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Grid2,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  createServiceConfigUrl,
  deleteServiceConfigUrl,
  getServiceConfigsByStoreIdUrl,
  servicesUrl,
  updateServiceConfigUrl,
} from "../../../utils/urls";
import axiosInstance from "../../../utils/axiosInstance";
import PageHeader from "../../../components/page-layout/PageHeader";
import LoadingUI from "../../../components/LoadingUI";
import EmptyListUi from "../../../components/EmptyListUi";
import ServiceTypeConfigAccordionCard from "../../../components/pages/services/ServiceTypeConfigAccordionCard";
import { useParams } from "react-router";
import { errorHandler } from "../../../utils/errorHandler";
import { toast } from "react-hot-toast";

const EditServices = ({ formData = {} }) => {
  const { storeId } = useParams();
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [services, setServices] = useState([]);
  const [fetchedSelectedServices, setFetchedSelectedServices] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);

  const [deleteIds, setDeleteIds] = useState([]);

  const deleteIdsHandler = (id) => {
    console.log({ id }, 8888888888);
    setDeleteIds((prev) => [...prev, id]);
  };

  useEffect(() => {
    if (formData.service) {
      setSelectedServices(formData.service);
    }
  }, [formData.services]);

  useEffect(() => {
    fetchServicesAndConfigs(storeId);
  }, [storeId]);

  const fetchServicesAndConfigs = async (storeId) => {
    setLoading(true);
    try {
      // Fetch all services
      const svcRes = await axiosInstance.get(servicesUrl);
      const svcData = Array.isArray(svcRes.data)
        ? svcRes.data
        : svcRes.data.data || [];

      const formattedServices = svcData.map((svc) => ({
        id: svc.id,
        name: svc.name.trim(),
        printPreference: svc.printPreference,
        isRequired: svc.isRequired,  
        isDefault: svc.isDefault,    
        description: svc.description,
        types: svc.service_types,
      }));

      setServices(formattedServices);

      // Fetch service configs by store ID
      const configRes = await axiosInstance.get(
        getServiceConfigsByStoreIdUrl(storeId)
      );
      const grouped = {};

      (configRes.data || []).forEach((item) => {
        console.log({ serviceConfigId: item.id });

        const serviceId = item.service.id;
        if (!grouped[serviceId]) {
          grouped[serviceId] = {
            id: serviceId,
            name: item.service.name,
            types: [],
          };
        }

        grouped[serviceId].types.push({
          id: item.serviceType.id,
          name: item.serviceType.name,
          icon: item.serviceType.icon,
          value: item.price,
          isInitial: true,
          serviceConfigId: item.id,
        });
      });

      const structured = Object.values(grouped);
      setSelectedServices(structured);
      setFetchedSelectedServices(structuredClone(structured));
      console.log(structured, 999);
    } catch (err) {
      errorHandler(err);
    } finally {
      setLoading(false);
    }
  };

  console.log({ selectedServices });

  /**
   * Handles changes to a service type selection.
   * Adds or updates the selected service and its types in the selectedServices state.
   *
   * @param {Object} type - The service type object being changed.
   * @param {Object} service - The parent service object.
   * @param {any} value - The new value for the service type.
   */
  const onChangeService = React.useCallback(
    (type, service, value, checked) => {
      console.log({ type, service, value }, 222);
      // Find if the service is already selected
      const foundIndexOfService = selectedServices.findIndex(
        (s) => s.id === service.id
      );

      if (foundIndexOfService === -1) {
        const newSelectedService = {
          id: service.id,
          name: service.name,
          types: [{ ...type, value, isInitial: false }], // Add the selected type with its value
        };

        const updatedSelectedServices = [
          ...selectedServices,
          newSelectedService,
        ];
        setSelectedServices(updatedSelectedServices);
      } else {
        // Service is already selected, update its types
        const foundService = selectedServices[foundIndexOfService];
        // Check if the type is already selected for this service
        const foundServiceTypeIndex = foundService.types.findIndex(
          (t) => t.id === type.id
        );

        console.log({ foundServiceTypeIndex });

        if (foundServiceTypeIndex === -1) {
          console.log(999);
          const foundFetchedService = fetchedSelectedServices.find(
            (s) => s.id === service.id
          );

          console.log({ foundFetchedService });

          let isInitial = false;
          if (foundFetchedService) {
            const foundFetchedServiceTypes = foundFetchedService.types;
            const isTypeExistInFetchedService = foundFetchedServiceTypes.find(
              (t) => t.id === type.id
            );
            console.log({
              foundFetchedServiceTypes,
              foundFetchedServiceTypesLength: foundFetchedServiceTypes.length,
              foundFetchedServiceTypes0Elt: foundFetchedServiceTypes[0],
            });
            isInitial = !!isTypeExistInFetchedService;
            let value = isTypeExistInFetchedService?.value || 0;

            foundService.types.push({
              ...type,
              isInitial: isInitial,
              value: value,
              serviceConfigId: isTypeExistInFetchedService?.serviceConfigId,
            });
          } else {
            // If type not found, add it to the types array
            foundService.types.push({ ...type, isInitial: false, value });
          }
        } else {
          if (checked === false)
            foundService.types = foundService.types.filter(
              (t) => t.id !== type.id
            );
          // If type exists, update its value
          else {
            foundService.types = foundService.types.map((t) => {
              if (t.id === type.id) {
                const updatedType = structuredClone(type);
                console.log({ type, t }, 7878);
                updatedType.value = value;
                updatedType.isInitial = type.isInitial;
                updatedType.serviceConfigId = type.serviceConfigId;
                return updatedType;
              }
              return t;
            });
          }
        }

        // Update the selectedServices state with the modified service
        const updatedSelectedServices = selectedServices.map((s) => {
          if (s.id === foundService.id) return foundService;
          return s;
        });
        setSelectedServices(updatedSelectedServices);
      }
    },
    [selectedServices, fetchedSelectedServices]
  );

  useEffect(() => {
    axiosInstance
      .get(servicesUrl)
      .then((svcRes) => {
        const svcData = Array.isArray(svcRes.data)
          ? svcRes.data
          : svcRes.data.data || [];
        const formatted = svcData.map((svc) => ({
          id: svc.id,
          name: svc.name.trim(),
          printPreference: svc.printPreference,
          isRequired: svc.isRequired ,  
          isDefault: svc.isDefault ,    
          types: svc.service_types,
          description: svc.description
        }));
        setServices(formatted);
        console.log({ svcData });
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const onSubmit = async () => {
    setIsSubmitting(true);
    let postTypeList = [],
      putTypeList = [],
      deleteServiceConfigList = [...new Set(deleteIds)];

    selectedServices.forEach((s) => {
      s.types.forEach((type) => {
        const typeBody = {
          serviceId: s.id,
          serviceTypeId: type.id,
          storeId: storeId,
          price: Number(type.value),
        };
        if (type.serviceConfigId) {
          typeBody.serviceConfigId = type.serviceConfigId;
        }
        if (type.isInitial) {
          putTypeList.push(typeBody);
          deleteServiceConfigList = deleteServiceConfigList.filter(
            (id) => type.serviceConfigId !== id
          );
        } else {
          postTypeList.push(typeBody);
        }
      });
    });

    try {
      const requests = [];

      // POST requests (create new types)
      postTypeList.forEach((type) => {
        requests.push(axiosInstance.post(createServiceConfigUrl, type));
      });

      // PUT requests (update existing types)
      putTypeList.forEach((type) => {
        requests.push(
          axiosInstance.patch(
            updateServiceConfigUrl(type.serviceConfigId),
            type
          )
        );
      });

      // DELETE requests (delete unwanted service types)
      deleteServiceConfigList.forEach((id) => {
        requests.push(axiosInstance.delete(deleteServiceConfigUrl(id)));
      });

      await Promise.all(requests);
      console.log("All operations successful");
      toast.success("Services changes updated");
    } catch (error) {
      errorHandler(error);
      console.error("Error while submitting types:", error);
    } finally {
      setIsSubmitting(false);
      setDeleteIds([]);
    }
  };

  console.log({ selectedServices });

  return (
    <Box>
      <Box>
        <PageHeader
          showBack={true}
          title={"Edit store services"}
          lead={
            "Select the services and their types that your store will offer. You can configure each service type as needed."
          }
          rightComponent={
            <Button
              variant="contained"
              onClick={onSubmit}
              disabled={isSubmitting}
            >
              Save Changes
            </Button>
          }
        />
        <Box
          sx={{
            p: 1,
            height: "calc(100vh - 140px)",
            overflowY: "auto",
          }}
        >
          <Stack gap={2}>
            {loading ? (
              <LoadingUI text="Loading services..." />
            ) : services.length === 0 ? (
              <EmptyListUi text="No services found. Ask Admin about this issue" />
            ) : isSubmitting ? (
              <LoadingUI text="Saving Service Configurations..." />
            ) : (
              services.map((service) => {
                return (
                  <ServiceTypeConfigAccordionCard
                    value={selectedServices.find((s) => s.id === service.id)}
                    onChangeService={onChangeService}
                    key={service.id}
                    service={service}
                    deleteIdsHandler={deleteIdsHandler}
                    defaultShow={false}
                  />
                );
              })
            )}
          </Stack>
        </Box>
      </Box>
      {console.log({ selectedServices })}
    </Box>
  );
};

export default EditServices;
